<template>
  <div>
    <van-tabbar v-model="active" :route="true">
      <van-tabbar-item to="/member/selectFun" name="selectFun" icon="eye-o"
        >占星</van-tabbar-item
      >
      <!-- <van-tabbar-item to="/article" name="article" icon="newspaper-o"
        >文章</van-tabbar-item
      >
      <van-tabbar-item to="/jewelry" name="jewelry" icon="newspaper-o"
        >珠宝</van-tabbar-item
      > -->
      <van-tabbar-item to="/member/index" name="member" icon="friends-o"
        >我的</van-tabbar-item
      >
    </van-tabbar>
  </div>
</template>

<script>
export default {
  data() {
    return {
      active: "selectFun",
    };
  },
  mounted () {
    this.$router.onReady(() => {
      let currentPage = this.$route.path;
      console.log(currentPage)

      if (currentPage.indexOf("/member/selectFun") > -1) {
        this.active = "selectFun"
      } else if (currentPage.indexOf("/article") > -1) {
        this.active = "article"
      } else if (currentPage.indexOf("/member/index") > -1) {
        this.active = "member"
      }
    });

  },
};
</script>
<style lang="less" scoped></style>
